var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row align-items-center h-100"},[_c('b-card',{staticClass:"col-6 offset-3"},[_c('h2',[_vm._v("500 - SERVER ERROR")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }